export const PRODUCTION = {
  url: 'https://portal.cloud.hashicorp.com/index.html',
};
export const INTEGRATION = {
  url: 'https://portal.hcp.to/index.html',
};
export const DEVELOPMENT = {
  url: 'https://portal.hcp.dev/index.html',
};

export const PRODUCTION_EU = {
  url: 'https://portal.cloud.eu.hashicorp.com/index.html',
};
export const INTEGRATION_EU = {
  url: 'https://portal.eu.int.hcp.global/index.html',
};
export const DEVELOPMENT_EU = {
  url: 'https://portal.eu.dev.hcp.global/index.html',
};
